// extracted by mini-css-extract-plugin
module.exports = {"gif":"y_bK","gif--wrapped":"y_bL"};